<template>
    <f7-list media-list style="margin:0px;height:100%;overflow:auto;">
        <f7-list-item v-for="(anime, index) in datos"
                      :link="'/anime/'+ anime.id"
                      :key="index"
                      :text="anime.sinopsis"
                      :title="anime.Nombre">
            <img slot="media" :src="anime.Imagen" width="80"/>
        </f7-list-item>
    </f7-list>
</template>

<script>
    export default {
        props: ['datos'],
        data() {
            return {}
        },
        methods: {},
        mounted() {
            let self = this;
            this.$f7ready((f7) => {
            })
        },
    }
</script>
